<template>
  <div>
    <main-overview :columns="columns" :statusKey="$route.params.status" />
  </div>
</template>

<script>
import MainOverview from "./Main";
export default {
  components: {
    MainOverview,
  },
  data() {
    return {
      columns: [
        {
          label: "Order Number",
          field: "id",
          type: "number",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Fabric",
          field: "fabric_id",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "C & C Outside",
          field: "collar_fabric_id",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Contrast",
          field: "inner_collar_fabric_id",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Age",
          field: "age",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Days",
          field: "days_in_current_step",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Incoming Date",
          field: "created_at",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Documents",
          field: "documents",
          sortable: false,
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
    };
  },
};
</script>
